export default __webpack_public_path__ + "static/media/team_fitri.61a76534.png";